<template>
	<footer class="footer has-cards">
		<div class="container">
			<hr />
			<div class="row align-items-center justify-content-between">
				<div class="col">
					<div class="copyright">
						&copy; {{ year }}
						<a href="/">AA Slovakia</a>
					</div>
				</div>
				<div class="col">
					<ul class="nav nav-footer justify-content-end">
						<li class="nav-item">
							<a href="https://wa.me/421949763805" target="_blank" class="nav-link">WhatsApp</a>
						</li>
						<li class="nav-item">
							<router-link :to="{ name: 'contact' }" class="nav-link">Контакты</router-link>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</footer>
</template>
<script>
export default {
	name: 'app-footer',
	data() {
		return {
			year: new Date().getFullYear(),
		};
	},
};
</script>
<style></style>

